import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ClovesImg from '../assets/banners/cloves.jpg';
import { FaLeaf, FaGlobe, FaFlask, FaBoxOpen } from 'react-icons/fa';

const Cloves = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Cloves Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your Cloves.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-orange-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-orange-800 mb-4">Premium Cloves</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Strong aroma, powerful flavor — our whole cloves are naturally sun-dried and globally exported for culinary and medicinal uses.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={ClovesImg}
                        alt="Cloves"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-orange-800 mb-6">Why Our Cloves Stand Out?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaFlask className="text-orange-600 mt-1" />High oil content (15%+) ensuring strong aroma and taste</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-orange-600 mt-1" />Handpicked & naturally dried without chemicals</li>
                        <li className="flex items-start gap-3"><FaBoxOpen className="text-orange-600 mt-1" />Variants: Whole Clove Buds, Clove Stems, Clove Powder</li>
                        <li className="flex items-start gap-3"><FaGlobe className="text-orange-600 mt-1" />Used in Masalas, Pickles, Ayurveda, Perfumery & more</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-orange-600 mt-1" />Sourced from India's top spice regions</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-orange-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-orange-800 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-orange-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 text-left bg-orange-100">Variants</th>
                                    <td className="p-4">Whole Cloves, Clove Stems, Clove Powder</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Origin</th>
                                    <td className="p-4">India, Sri Lanka, Indonesia</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Shelf Life</th>
                                    <td className="p-4">18 - 24 months</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Packaging</th>
                                    <td className="p-4">250g, 500g, 1kg, 25kg (Pouches, Cartons)</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-orange-100">Oil Content</th>
                                    <td className="p-4">Min. 15%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-orange-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 text-left bg-orange-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 270 kcal<br />
                                        Protein: 6g<br />
                                        Fat: 13g<br />
                                        Carbs: 65g<br />
                                        Fiber: 34g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-orange-100">Usage</th>
                                    <td className="p-4">
                                        Masala Blends, Ayurvedic Medicines, Pickles, Rice Dishes, Perfumes, Oils
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaFlask className="text-4xl mx-auto text-orange-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">High Oil Content</h4>
                </div>
                <div>
                    <FaLeaf className="text-4xl mx-auto text-orange-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Natural Drying</h4>
                </div>
                <div>
                    <FaGlobe className="text-4xl mx-auto text-orange-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Global Shipping</h4>
                </div>
                <div>
                    <FaBoxOpen className="text-4xl mx-auto text-orange-700 mb-2" />
                    <h4 className="font-semibold text-gray-700">Safe Packaging</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-orange-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-orange-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-orange-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-orange-700 hover:bg-orange-800 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Cloves;
